import dayjs from 'dayjs'

function tmapDateStringToDateTime(tmapDateString: string) {
  return dayjs(tmapDateString, 'YYYYMMDDHHmmss')
}

export { tmapDateStringToDateTime }
